import type { Meta, StoryFn } from '@storybook/react';

import { InfoDialogMock, InfoDialogProgressMock } from './InfoDialog.mocks';
import { FormDialogMock } from './FormDialog.mocks';

export default {
  title: 'Core/Dialog'
} as Meta;

export const InfoDialogDemo: StoryFn = () => {
  return <InfoDialogMock />;
};

export const InfoDialogProgressDemo: StoryFn = () => {
  return <InfoDialogProgressMock />;
};

export const FormDialogDemo: StoryFn = () => {
  return <FormDialogMock />;
};
